import axios from "axios";

export default {
  async trades(symbol) {
    return axios.get(`/api/enduser/fast/tradeBook?symbol=${symbol}`);
  },
  async orders(symbol) {
    return axios.get(`/api/enduser/fast/orderBook?symbol=${symbol}`);
  },
};